import Api from 'services/api'

import { UserGroup } from '../models/UserGroup'
import { CreateUserGroupDto, UpdateUserGroupDto, UserGroupDto } from '../types'

export const UserGroupRepository = {
  /**
   * Fetches user groups for a building
   */
  getUserGroups: async (buildingId: string | number): Promise<UserGroup[]> => {
    const bId = String(buildingId)
    const res: any = await Api.get(`/v1/buildings/${bId}/user-groups`)
    const rawList: UserGroupDto[] = Array.isArray(res)
      ? res
      : res?.data || res?.groups || []
    return rawList.map(UserGroup.from)
  },

  /**
   * Creates a new user group for a building
   */
  createUserGroup: async (
    buildingId: string | number,
    payload: CreateUserGroupDto
  ): Promise<UserGroup> => {
    const bId = String(buildingId)
    const res: any = await Api.post(`/v1/buildings/${bId}/user-groups`, payload)
    return UserGroup.from(res?.data || res)
  },

  /**
   * Updates an existing user group for a building
   */
  updateUserGroup: async (
    buildingId: string | number,
    groupId: number,
    payload: UpdateUserGroupDto
  ): Promise<UserGroup> => {
    const bId = String(buildingId)
    const res: any = await Api.patch(
      `/v1/buildings/${bId}/user-groups/${groupId}`,
      payload
    )
    return UserGroup.from(res?.data || res)
  },

  /**
   * Deletes a user group for a building
   */
  deleteUserGroup: async (
    buildingId: string | number,
    groupId: number
  ): Promise<void> => {
    const bId = String(buildingId)
    await Api.delete(`/v1/buildings/${bId}/user-groups/${groupId}`, {})
  }
}

export default UserGroupRepository
